// Reading a Drive file id out of a stored link. Runtime-neutral: the app and
// the functions (through _shared/lib) read a link the same way.

/** The Drive file id inside a stored link, or null if it is not a Drive link. */
export function driveFileId(url) {
  if (!url) return null;
  // Google's own hosts only: an id read out of any other address is not a
  // file AHFC filed.
  if (!/^https:\/\/(drive|docs)\.google\.com\//.test(url)) return null;
  const m = url.match(/\/d\/([A-Za-z0-9_-]{10,})/) || url.match(/[?&]id=([A-Za-z0-9_-]{10,})/);
  return m ? m[1] : null;
}
